import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { translate } from "@flow-frontend-npm/common";

import translations from "../../../translations.json";

// eslint-disable-next-line require-jsdoc
const t = (key) => translate(translations, key);

const SaveTemplateButton = ({
    clickOnTemplateCreation,
    saveSearchTemplateButtonLabel,
    tooltip,
    ...rest
}) => {
    return (
        <Tooltip title={tooltip}>
            <div>
                <Button
                    id="gridBtnSave"
                    variant="outlined"
                    onClick={clickOnTemplateCreation}
                    sx={{
                        whiteSpace: "nowrap",
                    }}
                    {...rest}
                >
                    {saveSearchTemplateButtonLabel ||
                        t("customGridToolbar.saveSearch")}
                </Button>
            </div>
        </Tooltip>
    );
};

SaveTemplateButton.propTypes = {
    clickOnTemplateCreation: PropTypes.func,
    saveSearchTemplateButtonLabel: PropTypes.string,
    tooltip: PropTypes.string,
};

export default SaveTemplateButton;
